import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient, Session } from '@benzinga/session';
import { MortgageRateTrendChartDataPointResponse } from './entities';
import { MortgageRatesManager } from './manager';

export class MortgageRatesRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(MortgageRatesManager).url, session, { 'x-device-key': true });
  }

  getMortgageRateTrends = (): SafePromise<MortgageRateTrendChartDataPointResponse> => {
    const url = this.URL('finance/rate-trends?is_refinance=false');
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      headers: {
        'X-RapidAPI-Host': 'us-real-estate.p.rapidapi.com',
        'X-RapidAPI-Key': '7cef1d1345msh58473aea32dc974p151ec0jsn596aac083df5',
      },
    });
  };
}
